import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Button, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import { toast } from 'react-toastify';
import ProcedureHistoryForm from './ProcedureHistoryForm';
import { addProcedureHistoryThunk, updateProcedureHistoryThunk } from '../../../slices/thunks';
import { resetProcedureHistoryFlags } from '../../../slices/procedureHistory/reducer';

const WaterRightHistoryForm = ({ waterRightData, dataToEdit, isOpen, handleToggleModal }) => {
	const dispatch = useDispatch();
	const formRef = useRef(null);

	// Redux selector
	const selectorProcedureHistory = createSelector(
		state => state.ProcedureHistory,
		procedureHistory => ({
			isAdding: procedureHistory?.isAdding,
			isAdded: procedureHistory?.isAdded,
			isUpdating: procedureHistory?.isUpdating,
			isUpdated: procedureHistory?.isUpdated,
			isCloseModal: procedureHistory?.isCloseModal,
		})
	);

	const { isAdding, isAdded, isUpdating, isUpdated, isCloseModal } = useSelector(selectorProcedureHistory);

	// Auto-close modal on success
	useEffect(() => {
		if (isCloseModal && (isAdded || isUpdated)) {
			handleToggleModal();
			// Reset flags after a small delay to allow Panel to detect requireRefetch
			setTimeout(() => {
				dispatch(resetProcedureHistoryFlags());
			}, 100);
		}
	}, [isCloseModal, isAdded, isUpdated, handleToggleModal, dispatch]);

	const handleSubmit = values => {
		if (!values.water_right_id) {
			toast.error('Error: No se pudo identificar el derecho de agua');
			return;
		}

		const submitData = {
			name: values.name,
			water_right_id: values.water_right_id,
			procedure_type_id: values.procedure_type_id,
			procedure_date: values.procedure_date,
		};

		if (dataToEdit?._id) {
			// Edit mode
			dispatch(updateProcedureHistoryThunk({ 
				id: dataToEdit._id, 
				data: submitData 
			}));
		} else {
			// Add mode
			dispatch(addProcedureHistoryThunk(submitData));
		}
	};

	const handleConfirm = () => {
		if (formRef.current) {
			formRef.current.handleSubmit();
		}
	};

	return (
		<>
			<ModalBody className='modal-body'>
				<ProcedureHistoryForm
					ref={formRef}
					onSubmit={handleSubmit}
					dataToEdit={dataToEdit}
					waterRightId={waterRightData?._id}
				/>
			</ModalBody>

			<ModalFooter>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						disabled={isAdding || isUpdating}
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="ri-close-line label-icon"></i>
						Cancelar
					</Button>
					<Button
						color='primary'
						className='btn btn-label btn-primary'
						onClick={handleConfirm}
						disabled={isAdding || isUpdating}
					>
						{(isAdding || isUpdating) ? (
							<i className='label-icon'>
								<Spinner size='sm' />
							</i>
						) : (
							<i className='ri-check-line label-icon'></i>
						)}
						{isUpdated ? 'Actualizar' : 'Guardar'}
					</Button>
				</div>
			</ModalFooter>
		</>
	);
};

export default WaterRightHistoryForm;
